module.exports = __webpack_public_path__ + "img/menu-minus-off.6f414995.svg";